import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import loginReducer from "./login/login.reducer";
import generalReducer from "./general/general.reducer";
import userTypeReducer from "./master/userType/userType.reducer";
import branchReducer from "./master/branch/branch.reducer";
import departmentReducer from "./master/department/department.reducer";
import productReducer from "./master/product/product.reducer";
import lenderReducer from "./master/lender/lender.reducer";
import leadsReducer from "./master/leads/leads.reducer";
import saleDetailsReducer from "./master/leads/saleDetails/saleDetails.reducer";
import staffReducer from "./master/staff/staff.reducer";
import companyReducer from "./superAdmin/company/company.reducer";
import profileReducer from "./profile/profile.reducer";
import attendanceReducer from "./operation/attendance/attendance.reducer";
import preproposalsReducer from "./operation/preProposals/preproposals.reducer";
import diallerPushLogReducer from "./report/diallerPushLog/diallerPushLog.reducer";
import viewBusinessReducer from "./report/viewBusinessDetails/viewBusinessDetails.redcuer";
import callBackReducer from "./report/callBack/callBack.reducer";
import statusCountReducer from "./report/status-count/status-count.reducer";
import tcnResponseReducer from "./report/tcnResponse/tcnResponse.reducer";
import performanceReportReducer from "./report/performanceReport/performanceReport.reducer";
import submittedProposalsReportReducer from "./report/submittedProposalsReport/submittedProposalsReport.reducer";
import rpcNonResponseReducer from "./report/rpcReport/rpcNonReport.reducer";
import averageMonthlyPerformanceReportReducer from "./report/averageMonthlyPerformanceReport/averageMonthlyPerformanceReport.reducer";
// import requestReportReducer from "./report/requestReport/requestReport.reducer";
import webEnquiryReducer from "./report/webEnquiry/webEnquiry.reducer";
import funderReducer from "./master/funder/funder.reducer";
import assignUsersRightsReducer from "./assign/assign-users-rights/assign-users-rights.reducer";
import DashboardReducer from "./master/dashboard/Dashboard.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["base_login"],
};
const rootReducer = combineReducers({
  base_login: loginReducer,
  general: generalReducer,
  //MASTERS
  userType_master: userTypeReducer,

  branch_master: branchReducer,
  department_master: departmentReducer,
  product_master: productReducer,
  lender_master: lenderReducer,
  funder_master: funderReducer,
  listUserControl_details: assignUsersRightsReducer,

  leads_master: leadsReducer,
  saleDetails: saleDetailsReducer,
  staff_master: staffReducer,
  company_master: companyReducer,
  profile: profileReducer,
  attendance: attendanceReducer,
  preproposals: preproposalsReducer,
  diallerPush: diallerPushLogReducer,
  viewbusiness: viewBusinessReducer,
  callback: callBackReducer,
  statusCount: statusCountReducer,
  tcnresponse: tcnResponseReducer,
  performanceReport: performanceReportReducer,
  submittedProposalsReport: submittedProposalsReportReducer,
  webEnquiry: webEnquiryReducer,
  rpcNonReport: rpcNonResponseReducer,
  averageMonthlyPerformanceReport: averageMonthlyPerformanceReportReducer,
  // requestReport_master: requestReportReducer,
  dashboard: DashboardReducer,
});

export default persistReducer(persistConfig, rootReducer as any);
